import React from 'react'
import NotFoundImage from '../../../statics/assets/images/403.svg'

function NotFound() {
    return (
        <div className="NotFound">
            <NotFoundImage/>

            <div className="PageNotFound">
                <h6>Access Denied/Forbidden</h6>
                <p>Bạn không có quyền truy cập vào trang này, vui lòng liên hệ Admin.</p>
            </div>
        </div>
    )
}

export default NotFound